import React from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TelegramIcon from '@mui/icons-material/Telegram';
import './Dashboard.css';
import Background from '../../common/Background';
import Cardimg2 from "../../../assets/img/illustrations/corner-4.png";
import { settings } from '../../../config';

const SocialLinksCard = () => {
  const formatWhatsAppLink = (input) => {
    if (!input) return '#';
    const digits = String(input).replace(/\D/g, '');
    return digits ? `https://wa.me/${digits}` : String(input);
  };


  const whatsappHref = formatWhatsAppLink(settings.WhatsApp);
  const telegramHref = settings.Telegram;

  return (
    <Background image={Cardimg2} className="bg-card">
      <div className="quick-link-content">
        <div className="quick-link-text">
          <h3 className="quick-link-title">Join our community</h3>
          <p className="quick-link-description">Get updates and support on WhatsApp and Telegram</p>
        </div>
      </div>
      <div className="social-actions">
        <a className="social-btn whatsapp" href={whatsappHref} target="_blank" rel="noreferrer noopener">
          <WhatsAppIcon /> WhatsApp
        </a>
        <a className="social-btn telegram" href={telegramHref} target="_blank" rel="noreferrer noopener">
          <TelegramIcon /> Telegram
        </a>
      </div>
    </Background>
  );
};

export default SocialLinksCard;


